/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DocumentToSubmitType } from './DocumentToSubmitType';
import {
    DocumentToSubmitTypeFromJSON,
    DocumentToSubmitTypeFromJSONTyped,
    DocumentToSubmitTypeToJSON,
} from './DocumentToSubmitType';

/**
 * 
 * @export
 * @interface AddDocumentToPalAuthSubmissionRequest
 */
export interface AddDocumentToPalAuthSubmissionRequest {
    /**
     * 
     * @type {DocumentToSubmitType}
     * @memberof AddDocumentToPalAuthSubmissionRequest
     */
    type: DocumentToSubmitType;
    /**
     * 
     * @type {string}
     * @memberof AddDocumentToPalAuthSubmissionRequest
     */
    s3_key: string;
    /**
     * 
     * @type {string}
     * @memberof AddDocumentToPalAuthSubmissionRequest
     */
    custom_name?: string;
}

/**
 * Check if a given object implements the AddDocumentToPalAuthSubmissionRequest interface.
 */
export function instanceOfAddDocumentToPalAuthSubmissionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "s3_key" in value;

    return isInstance;
}

export function AddDocumentToPalAuthSubmissionRequestFromJSON(json: any): AddDocumentToPalAuthSubmissionRequest {
    return AddDocumentToPalAuthSubmissionRequestFromJSONTyped(json, false);
}

export function AddDocumentToPalAuthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddDocumentToPalAuthSubmissionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': DocumentToSubmitTypeFromJSON(json['type']),
        's3_key': json['s3_key'],
        'custom_name': !exists(json, 'custom_name') ? undefined : json['custom_name'],
    };
}

export function AddDocumentToPalAuthSubmissionRequestToJSON(value?: AddDocumentToPalAuthSubmissionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': DocumentToSubmitTypeToJSON(value.type),
        's3_key': value.s3_key,
        'custom_name': value.custom_name,
    };
}

